import { AfterViewInit, ContentChild, Directive, OnDestroy, TemplateRef } from '@angular/core';
import { ToolbarService } from 'bookraw/shared/services/toolbar.service';

@Directive({ selector: 'app-toolbar-injector' })
export class ToolbarInjectorDirective implements AfterViewInit, OnDestroy {

  @ContentChild(TemplateRef, { read: TemplateRef, static: true })
  private toolbarTemplateQuery: TemplateRef<any>;

  constructor(private toolbarService: ToolbarService) {
  }

  ngAfterViewInit(): void {
    this.toolbarService.template.next(this.toolbarTemplateQuery);
  }

  ngOnDestroy(): void {
    this.toolbarService.template.next(null);
  }
}
